import React, { useState, useEffect } from 'react'
import { Menu, MenuItem } from '@mui/material'
import { TreeChild } from '../../../types'
import NestedMenuItem from 'src/components/NestedMenuItem'

interface MenuPosition {
  left: number
  top: number
}

interface RenderMenuProps {
  treeChildren?: TreeChild[]
  menuPosition: MenuPosition
  handleLeafClick: (event: any, id: string) => void
  children?: React.ReactNode
}

const RenderMenu = ({
  treeChildren = [],
  menuPosition,
  handleLeafClick,
}: RenderMenuProps) => {
  return (
    <div>
      {treeChildren.map((child, idx) => {
        if (child.leaf) {
          return (
            <MenuItem
              key={child.title}
              onClick={(event) => handleLeafClick(event, child.id)}
            >
              {child.title}
            </MenuItem>
          )
        }
        return (
          <NestedMenuItem
            key={child.title}
            label={child.title}
            parentMenuOpen={!!menuPosition}
          >
            <RenderMenu
              key={idx}
              handleLeafClick={handleLeafClick}
              menuPosition={menuPosition}
              treeChildren={child.children || []}
            >
              {child.children as any}
            </RenderMenu>
          </NestedMenuItem>
        )
      })}
    </div>
  )
}

interface Props {
  isMenuOpen: boolean
  event: any
  activeTree?: TreeChild
  handleLeafClick: (event: any, id: string) => void
  handleClose: () => void
}

export const MultiMenu = ({
  isMenuOpen,
  event,
  activeTree,
  handleLeafClick,
  handleClose,
}: Props) => {
  const [menuPosition, setMenuPosition] = useState({ left: 0, top: 0 })

  useEffect(() => {
    if (isMenuOpen) {
      setMenuPosition({
        left: event.clientX,
        top: event.clientY,
      })
    }
  }, [event.clientX, event.clientY, isMenuOpen])

  return (
    <Menu
      open={isMenuOpen}
      onClose={handleClose}
      anchorReference="anchorPosition"
      anchorPosition={menuPosition}
    >
      <RenderMenu
        handleLeafClick={handleLeafClick}
        menuPosition={menuPosition}
        treeChildren={activeTree?.children}
      />
    </Menu>
  )
}

export default MultiMenu
